import React , {useState, useRef, useEffect} from 'react';
import './DropDown.css'

const DropDown = ({
	button, 
	children, 
	ignoreDropDown, 
	fullWidth, 
	customButtonStyle, 
	dropdownStyle,
	readOnly=false
}) => {
	const [show, setShow] = useState(false);
	const dropdownRef = useRef(null);
	const mainRef = useRef(null);

	useEffect(() => {
	  const handleClickOutside = (event) => {

	    if (dropdownRef.current && !dropdownRef.current.contains(event.target) && !mainRef.current.contains(event.target)) {
	      setShow(false)
	    }
	  }

	  document.addEventListener("mousedown", handleClickOutside);
	  return () => {
	    document.removeEventListener("mousedown", handleClickOutside);
	  };
	}, []);

	return (
		<>
			<div ref={mainRef} className={`flex gap items-center filter_button ${fullWidth && "full flex justify-center"} ${readOnly && "readonly"} ${customButtonStyle}`} onClick={() => setShow(!show)}>
				{button}
			</div>
			{
				!readOnly && !ignoreDropDown &&
				<div  ref={dropdownRef} className={`dropdown shadow ${!show && 'dropdown_hide'} ${dropdownStyle}`} onClick={()=>setShow(!show)}>
					{children}
				</div>	
			}
				
		</>
	)
}

export default DropDown